import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { a as addScrollBarListener } from './scrollbar-DHAl7Frv.js';
import { a as addPrevNextButtonClickHandlers } from './arrow-buttons-CY1f9syu.js';
import { o as observeCarouselVisibility } from './visibility-1aJUVV5h.js';

class FeaturedBlogSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType | undefined} */
  #embla;
  /** @type {ReturnType<typeof observeCarouselVisibility> | null} */
  #visibility = null;

  connectedCallback() {
    this.#visibility = observeCarouselVisibility(this, {
      onEnter: () => {
        this.#embla = EmblaCarousel(this.querySelector('.embla__viewport'), {
          align: 'start',
          containScroll: 'trim',
          dragFree: true,
          skipSnaps: true,
          slidesToShow: 1.2,
          direction: document.dir,
          breakpoints: {
            '(min-width: 768px)': {
              slidesToShow: 4,
            },
          },
        });

        const scrollbar = this.querySelector('.embla__scrollbar');
        if (scrollbar) addScrollBarListener(this.#embla, scrollbar);

        const prevBtn = this.querySelector('.embla-button--prev');
        const nextBtn = this.querySelector('.embla-button--next');
        if (prevBtn && nextBtn) addPrevNextButtonClickHandlers(this.#embla, prevBtn, nextBtn);
      },
      getEmbla: () => this.#embla,
    });
  }

  disconnectedCallback() {
    this.#visibility?.disconnect();
    this.#embla?.destroy();
    this.#embla = undefined;
  }
}

customElements.define('featured-blog', FeaturedBlogSlider);
